// How a queue row's author record got into the users store. Only UNAVAILABLE renders an error state —
// see src/store/helpers/user_load.js for why a missing author stays quiet.
export const USER_LOAD_STATUSES = {
    LOADED: 'loaded',
    PENDING: 'pending',
    MISSING: 'missing',
    UNAVAILABLE: 'unavailable',
};
